import { NgModule } from "@angular/core";
import { TooltipListPipe } from "./tooltip-list.pipe";
import { FilesizePipe } from "./filesize.pipe";
import { MentionsPipe } from "./mentions.pipe";
import { OrderByPipe } from './order-by.pipe';
import { VoteListPipe } from './vote-list.pipe';
import { FollowtooltipPipe } from './followtooltip.pipe';
import { FilterPipe } from './filter.pipe';
import { GenericFilterPipe } from './generic-filter.pipe';

@NgModule({
    declarations: [
        TooltipListPipe,
        FilesizePipe,
        MentionsPipe,
        OrderByPipe,
        VoteListPipe,
        FollowtooltipPipe,
        FilterPipe,
        GenericFilterPipe,
    ],
    exports: [
        TooltipListPipe,
        FilesizePipe,
        MentionsPipe,
        OrderByPipe,
        VoteListPipe,
        FollowtooltipPipe,
        FilterPipe
    ],
})
export class PipesModule { }
